<template>
  <section ref="section" class="two-large-images -visibility-auto">
    <Observer name="fade-up" v-if="items" @enter="enter">
      <div class="container">
        <div class="row justify-content-center">
          <div class="col-12 col-md-5 tile" v-for="(bloc, i) in items" :key="bloc.title + '_' + i">
            <button v-if="bloc.products && bloc.products.length > 0" type="button" @click="onOpenModal(bloc)" class="btn-preview font-btn">
              <i class="icon-cart" />
              <span>{{ $t('Watch preview') }}</span>
            </button>
            <a v-if="bloc.link && bloc.link.url" :href="bloc.link.url" class="visual" target="_blank">
              <button type="button" @click="onOpenModal(bloc)" class="btn-icon font-btn">
                <i :class="'icon-' + (bloc.icon ? bloc.icon : 'star')" />
                <span v-if="bloc.link.text" class="h5">{{ bloc.link.text }}</span>
              </button>
              <video :ref="'video-' + i" v-if="bloc.video && bloc.video.url" autoplay playsinline loop muted>
                <source :src="bloc.video.url" type="video/mp4">
              </video>
              <lazy-picture v-else :item="bloc" desktop-ratio="1.778" mobile-ratio="1.778" />
            </a>
            <div class="visual" v-else>
              <video :ref="'video-' + i" v-if="bloc.video && bloc.video.url" autoplay playsinline loop muted>
                <source :src="bloc.video.url" type="video/mp4">
              </video>
              <lazy-picture v-else :item="bloc" desktop-ratio="1.778" mobile-ratio="1.778" />
            </div>
            <button v-if="bloc.video && bloc.video.url" type="button" class="btn-autoPlay" :class="{'-paused': pauseVideo[i]}" :aria-label="pauseVideo[i] ? 'Play' : 'Pause'" @click="toggleVideo(i)" />
          </div>
        </div>
      </div>
    </Observer>
    <ModalProduct :is-open="openModalProduct" :data="dataModalProduct" @close="onCloseModal" />
  </section>
</template>

<script>
import { currentStoreView } from '@vue-storefront/core/lib/multistore'
import { ReadyHook } from 'vue-asyncready'
import LazyPicture from '../components/utils/LazyPicture'

export default {
  mixins: [ReadyHook],
  name: 'two_large_images',
  props: ['item', 'items', 'pagePosition', 'siblings-components'],
  components: {
    LazyPicture,
    ModalProduct: () => import('./ModalProduct')
  },
  data () {
    return {
      openModalProduct: false,
      dataModalProduct: null,
      pauseVideo: [false, false],
      appeared: false
    }
  },
  computed: {
    localizedUrl () {
      const { url } = currentStoreView()
      return url || ''
    }
  },
  methods: {
    enter () {
      if (!this.appeared) {
        this.$refs.section.classList.remove('-visibility-auto')
        this.appeared = true
      }
    },
    leave() {
      if (this.$refs['video-0'] && !this.$refs['video-0'][0].paused) this.$refs['video-0'][0].pause()
      if (this.$refs['video-1'] && !this.$refs['video-1'][0].paused) this.$refs['video-1'][0].pause()
    },
    toggleVideo (i) {
      if (this.pauseVideo[i]) {
        this.$refs['video-' + i][0].play()
      } else {
        this.$refs['video-' + i][0].pause()
      }
      this.$set(this.pauseVideo, i, !this.pauseVideo[i])
    },
    onOpenModal (data) {
      this.dataModalProduct = data
      this.openModalProduct = true
    },
    onCloseModal () {
      this.openModalProduct = false
      this.dataModalProduct = null
    }
  },
  created () {},
  mounted () {},
  destroyed () {}
}
</script>

<style lang="scss" scoped>
@import '~theme/css/core';

section {
  position: relative;
  margin: 3rem 0;

  @include bp(max md) {
    margin: 1.5rem 0;
  }
}

.tile {
  /deep/ img {
    width: 100%;
  }
  /deep/ video {
    width: 100%;
  }

  @include bp(max md) {
    &:first-child {
      margin-bottom: 1.5rem;
    }
  }

  .visual {
    display: block;
    overflow: hidden;

    &:hover, &:focus, &:active {
      .btn-icon {
        max-width: 20rem;
        transition: max-width 0.3s 0s ease-out;

        span {
          opacity: 1;
          transition: opacity 0.3s 0s ease-out;
        }
      }
    }
  }
}

.btn-icon,
.btn-preview {
  z-index: 20;
  position: absolute;
  height: 3.5rem;
  color: var(--zenith-theme-primary);
  border: none;
  margin: 0;
  overflow: hidden;
  padding: 1rem 1rem 1rem 0.8rem;
  border-radius: 3.5rem;
  background-color: var(--zenith-white);
  text-align: center;
  vertical-align: middle;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  max-width: 3.5rem;
  cursor: pointer;
  transition: max-width 0.3s 0.15s ease-out;

  i {
    font-size: 2rem;
  }

  span {
    white-space: nowrap;
    text-transform: uppercase;
    margin-left: 1rem;
    opacity: 0;
    transition: opacity 0.3s 0s ease-in;
  }

  &:hover, &:active, &:focus {
    max-width: 20rem;
    transition: max-width 0.3s 0s ease-out;

    span {
      opacity: 1;
      transition: opacity 0.3s 0s ease-out;
    }
  }
}

.btn-preview {
  top: 3rem;
  right: 4.5rem;

  @include bp(max md) {
    top: 1rem;
    right: 2.5rem;
  }
}

.btn-icon {
  bottom: 3rem;
  left: 50%;
  transform: translateX(-50%);
  pointer-events: none;

  @include bp(max md) {
    bottom: 1rem;
  }
}

.btn-autoPlay {
  z-index: 50;
  right: 4.5rem;
  bottom: 3rem;
  width: 3.5rem;
  height: 3.5rem;
  outline-color: var(--zenith-theme-primary);

  @include bp(max md) {
    bottom: 1rem;
    right: 2.5rem;
  }

  &:hover, &:focus {
    background: var(--zenith-theme-primary);

    &:before {
      border-left-color: var(--zenith-white);
    }

    &:after {
      border-left-color: var(--zenith-white);
      border-right-color: var(--zenith-white);
    }
  }

  &:before {
    border-left: 6px solid var(--zenith-theme-primary);
  }
  &:after {
    border-right: 2px solid var(--zenith-theme-primary);
    border-left: 2px solid var(--zenith-theme-primary);
  }
}

</style>
